document.querySelectorAll(".accordion_head").forEach(function (accordionHead) {
  accordionHead.addEventListener("click", function () {
    var accordionBody = this.nextElementSibling;
    document.querySelectorAll(".accordion_body").forEach(function (body) {
      if (body !== accordionBody && body.style.display !== "none") {
        body.style.display = "none";
        var plusminus = body.previousElementSibling.querySelector(".plusminus");
        if (plusminus) plusminus.textContent = "+";
      }
    });

    // Toggle the visibility of the accordion body
    if (window.getComputedStyle(accordionBody).display === "none") {
      accordionBody.style.display = "block";
      var plusminus = this.querySelector(".plusminus");
      if (plusminus) plusminus.textContent = "-";
    } else {
      accordionBody.style.display = "none";
      var plusminus = this.querySelector(".plusminus");
      if (plusminus) plusminus.textContent = "+";
    }
  });
});
